module.exports = __webpack_public_path__ + "img/icon-car-w.514cd975.svg";